import React, { useContext, useState, useEffect } from "react";
import {
    AppBar,
    Button,
    ButtonGroup,
    Grid,
    IconButton,
    TextField,
    Toolbar,
    Typography,
    Box,
    Badge
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import DeleteIcon from '@mui/icons-material/Delete';
import ReplayIcon from '@mui/icons-material/Replay';
import DialogMenuMobile from './owner.room.dialog.menu.mobile';
import { getDisplayDate, formatVariants } from '../../../functions';
import { DashboardContext } from '../../../contexts/dashboard.context';

export default function RoomViewMobile({
    businessId,
    handleClose,
    classes,
    tableId,
    table,
    handleClickEdit,
    settingsDataDelivery,
    handleChangeTotalPrice,
    isEditing,
    paymentIntentId,
    totalPrice,
    getSumTotal,
    calculateTotalWithFees,
    lastUpdate,
    setScontoTotalPrice,
    getCategory,
    eraseOrder,
    handleCloseDialogAccept,
    setOpenDialogReject,
    openDialogReject,
    setOpenDialogComplete,
    openDialogComplete,
    handleClickRemove
}) {
    const { setDish, getDish, modifyTable, getTable, setTable, dataMenuObj } = useContext(DashboardContext);
    const [openDialogMenuMobile, setOpenDialogMenuMobile] = useState(false);
    const [amounts, setAmounts] = useState({});

    const handleTogglePrintedMobile = (dishId) => {
        const [myDish] = getDish(tableId, dishId);
        const newPrinted = myDish.printed === 1 ? 0 : 1;
        setDish(tableId, dishId, { ...myDish, printed: newPrinted });

        setTimeout(() => {
            modifyTable(table.id, table);
        }, 1000);
    };


    const deleteItem = (tableId, dishId) => {
        let [myTable] = getTable(tableId);
        if (myTable) {
            const myDishIndex = myTable.reservations
                .map(({ id }) => id)
                .indexOf(dishId);
            if (myDishIndex !== -1) {
                let r = [...myTable.reservations];
                r[myDishIndex].status = "owner_deleted";
                setTable(tableId, { ...myTable, reservations: r });
                setScontoTotalPrice(0);
            }
        }

        setTimeout(() => {
            modifyTable(table.id, table);
        }, 1000);
    };

    const restoreItem = (tableId, dishId) => {
        let [myTable] = getTable(tableId);
        if (myTable) {
            const myDishIndex = myTable.reservations
                .map(({ id }) => id)
                .indexOf(dishId);
            if (myDishIndex !== -1) {
                let r = [...myTable.reservations];
                r[myDishIndex].status = "preparation";

                setTable(tableId, { ...myTable, reservations: r });
            }
        }

        setTimeout(() => {
            modifyTable(table.id, table);
        }, 1000);
    };


    const handleChangeDish = (dishId, value) => {
        const [myDish] = getDish(tableId, dishId);
        setDish(tableId, dishId, { ...myDish, ...value });
    };

    const handleChangeAmount = (dishId, value) => {
        if (value < 1) return;

        const updatedAmounts = { ...amounts, [dishId]: value };
        setAmounts(updatedAmounts);

        const [myDish] = getDish(tableId, dishId);
        myDish.amount = value;
        setDish(tableId, dishId, { ...myDish });
        handleChangeTotalPrice(undefined, 'dishRow');

        setTimeout(() => {
            modifyTable(table.id, table);
        }, 3000);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const reservations = table && Array.isArray(table.reservations) ? table.reservations : [];


    const handleClickOrder = () => {
        if (openDialogMenuMobile) {
            sessionStorage.removeItem('cart');
            eraseOrder();
        }

        setOpenDialogMenuMobile(prev => !prev);
    };

    useEffect(() => {
        if (reservations.length > 0) {
            const initialAmounts = {};
            reservations.forEach((dish) => {
                initialAmounts[dish.id] = dish.amount || 1;
            });
            setAmounts(initialAmounts);
        }
    }, [reservations]);


    return (
        <div id="roomViewMobile" style={{ overflowY: 'auto', height: '100%' }}>
            <AppBar position="sticky">
                <Toolbar >
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6">
                        {table ? (table?.tableId ? `Tavolo ${table.tableId}` : table?.tipo + ' - ' + table?.nome + ' ' + table?.cognome) : 'Tavolo ' + tableId}
                    </Typography>
                </Toolbar>
            </AppBar>

            {openDialogMenuMobile && (
                <DialogMenuMobile
                    table={table}
                    tableId={tableId}
                    openDialog={openDialogMenuMobile}
                    setOpenDialog={setOpenDialogMenuMobile}
                    handleClickOrder={handleClickOrder}
                    dataMenuObj={dataMenuObj}
                    ownerId={businessId}
                />
            )}

            {reservations.length > 0 ? (
                <div style={{ padding: '10px' }}>
                    <Box
                        sx={{
                            mb: 2,
                            mt: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            gutterBottom
                        >
                            Ultima ordinazione: {getDisplayDate(lastUpdate)}
                        </Typography>
                        {totalPrice > 0 && table.accettato !== 0 && !isEditing && (
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => setOpenDialogComplete(!openDialogComplete)}
                            >
                                Completa
                            </Button>
                        )}
                        {totalPrice === 0 && (
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={handleClickRemove}
                            >
                                elimina ordini
                            </Button>
                        )}
                    </Box>

                    {reservations.map((el) => {
                        const isDeleted = el.status === 'owner_deleted';
                        return (
                            <Box
                                key={el.id}
                                sx={{
                                    mb: 1,
                                    p: 2,
                                    border: '1px solid rgba(0,0,0,0.12)',
                                    borderRadius: 2,
                                    bgcolor: 'background.paper',
                                    boxShadow: 3,
                                }}
                            >
                                <Grid container direction="column" spacing={1}>
                                    <Grid item xs={12}>
                                        <Box position="relative" p={1} >

                                            {/* Pulsante in alto a destra */}
                                            <IconButton
                                                onClick={() => isDeleted ? restoreItem(tableId, el.id) : deleteItem(tableId, el.id)}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    right: 8,
                                                }}
                                            >
                                                {isDeleted ? <ReplayIcon /> : <DeleteIcon />}
                                            </IconButton>

                                            {/* Contenuto condizionale */}
                                            {isEditing && !isDeleted ? (
                                                <Box display="flex" flexDirection="column" gap={1}>
                                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                                        <ButtonGroup size="small">
                                                            <Button
                                                                aria-label="delete"
                                                                variant="outlined"
                                                                onClick={() => handleChangeAmount(el.id, (amounts[el.id] || 1) - 1)}
                                                                disabled={(amounts[el.id] || 1) <= 1}
                                                            >
                                                                <RemoveIcon fontSize="inherit" />
                                                            </Button>
                                                            <Button disableRipple>{amounts[el.id] || 1}</Button>
                                                            <Button
                                                                aria-label="add"
                                                                variant="outlined"
                                                                onClick={() => handleChangeAmount(el.id, (amounts[el.id] || 1) + 1)}
                                                            >
                                                                <AddIcon fontSize="inherit" />
                                                            </Button>
                                                        </ButtonGroup>
                                                    </Box>

                                                    <Typography variant="subtitle1" fontWeight="bold">
                                                        {el.name}
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Box display="flex" alignItems="center">
                                                    <Badge
                                                        badgeContent={isDeleted ? <del>x{el.amount}</del> : `x${el.amount}`}
                                                        color={isDeleted ? "error" : "primary"}
                                                        sx={{
                                                            mr: 3,
                                                            '& .MuiBadge-badge': {
                                                                fontSize: '0.8rem',
                                                                minWidth: '22px',
                                                                height: '22px',
                                                            },
                                                        }}
                                                    />
                                                    <Typography
                                                        sx={isDeleted ? { textDecoration: 'line-through', color: '#b71c1c' } : {}}
                                                    >
                                                        <strong>{el.name}</strong>
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </Grid>

                                    {el.variant && (
                                        <Grid item>
                                            {isEditing && !isDeleted ? (
                                                <TextField
                                                    label="Variante"
                                                    value={el.variant}
                                                    onChange={(e) => handleChangeDish(el.id, { variant: e.target.value })}
                                                    fullWidth
                                                    multiline
                                                    InputProps={{
                                                        style: {
                                                            resize: 'none',  // Disabilita il ridimensionamento manuale
                                                            width: '250px',
                                                            height: 'fit-content'
                                                        },
                                                    }}
                                                />
                                            ) : (
                                                <Box sx={isDeleted ? { textDecoration: 'line-through' } : {}}>
                                                    {formatVariants(el.variant)}
                                                </Box >
                                            )}
                                        </Grid>
                                    )}

                                    {el.note && (
                                        <Grid item>
                                            <Typography sx={isDeleted ? { textDecoration: 'line-through' } : {}} color="text.secondary">
                                                Note: {el.note}
                                            </Typography>
                                        </Grid>
                                    )}

                                    <Grid item sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <IconButton
                                                onClick={() => handleTogglePrintedMobile(el.id)}
                                                size="small"
                                                disabled={isDeleted}
                                                sx={{
                                                    border: '1px solid rgba(0,0,0,0.2)',
                                                    backgroundColor: 'rgba(0,0,0,0.05)',
                                                    borderRadius: '50%',
                                                    p: 0.5,
                                                }}
                                            >
                                                {el.printed === 1 ? (
                                                    <CheckCircleIcon color="primary" fontSize="small" />
                                                ) : (
                                                    <AccessTimeFilledIcon fontSize="small" color="warning" />
                                                )}
                                            </IconButton>

                                            <Typography sx={isDeleted ? { textDecoration: 'line-through' } : {}} color='textSecondary' variant="body2">
                                                {el.printed === 1 ? 'Completato' : 'In preparazione'}
                                            </Typography>
                                        </Box>

                                        <Typography sx={isDeleted ? { textDecoration: 'line-through' } : {}}>
                                            {(el.amount * el.price).toFixed(2).replace('.', ',')} €
                                        </Typography>
                                    </Grid>

                                </Grid>
                            </Box>
                        );
                    })}

                    {table.deliveryId && table?.tipo?.toLowerCase() === 'consegna' && (
                        <Typography variant="body1" color="primary" align="right" sx={{ mt: 2 }}>
                            Subtotale: {totalPrice ? totalPrice.toFixed(2).toString().replace('.', ',') : 0} €
                        </Typography>
                    )}

                    {table.tipo?.toLowerCase() === 'consegna' && (
                        <Typography variant="body1" color="primary" align="right" sx={{ mt: 0.5 }}>
                            Costo consegna: {settingsDataDelivery?.costoConsegna ? parseFloat(settingsDataDelivery.costoConsegna).toFixed(2).toString().replace('.', ',') : 0} €
                        </Typography>
                    )}

                    {paymentIntentId && paymentIntentId.toLowerCase() !== 'pagato' && (
                        <Typography variant="body1" color="primary" align="right" sx={{ mt: 0.5 }}>
                            Costi di servizio: {calculateTotalWithFees(Number(getSumTotal()), true, paymentIntentId ? 'carta' : 'cassa').replace('.', ',')} €
                        </Typography>
                    )}

                    {table?.coupon_used && table.coupon_used !== 'none' && (
                        <Typography variant="body1" color="primary" align="right" sx={{ mt: 0.5 }}>
                            Usato coupon {table.coupon_used === 'fedelta' ? 'fedeltà' : table.coupon_used}: - {Number(table.coupon_value || 0).toFixed(2).toString().replace('.', ',')} €
                        </Typography>
                    )}

                    <Typography variant="h6" color="primary" align="right" sx={{ mt: 1.5 }}>
                        TOTALE: {calculateTotalWithFees(Number(getSumTotal()), false, (paymentIntentId && paymentIntentId.toLowerCase() !== 'pagato') ? 'carta' : 'cassa').replace('.', ',')} €
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', mt: 3, mb: 2, gap: 1 }}>
                        {table.accettato === 0 ? (
                            <>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => setOpenDialogReject(!openDialogReject)}
                                >
                                    Rifiuta ordine
                                </Button>

                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCloseDialogAccept(table.deliveryId)}
                                >
                                    Accetta ordine
                                </Button>
                            </>
                        ) : (
                            isEditing ? (
                                <Button
                                    fullWidth
                                    onClick={handleClickEdit}
                                    variant="contained"
                                    color="secondary"
                                >
                                    TERMINA
                                </Button>
                            ) : (
                                <>
                                    <Button
                                        fullWidth
                                        onClick={handleClickEdit}
                                        variant="contained"
                                        color="primary"
                                    >
                                        MODIFICA
                                    </Button>
                                    <Button
                                        fullWidth
                                        onClick={handleClickOrder}
                                        variant="contained"
                                        color="primary"
                                    >
                                        ORDINA
                                    </Button>
                                </>
                            )
                        )}
                    </Box>
                </div>
            ) : (
                <div className={classes.centeredIcon}>
                    <PersonOffIcon style={{ fontSize: 90 }} />
                    <Typography variant="subtitle1" color="textSecondary" align="center">
                        Non ci sono ordini associati a questo tavolo al momento
                    </Typography>
                </div>
            )}
        </div>
    );
}
